import type { ReactNode } from 'react';

import { ComboboxField } from '@/_shared/components/ui/combobox';

import { SEAMLESS_TRIGGER } from './lib/fused';

export interface FusedSelectOption {
  value: string;
  label: string;
  icon?: ReactNode;
  meta?: ReactNode;
}

/** A popover-style single-select — the design-system `ComboboxField` (popup variant), frame-dropped to
 *  sit inside an InputGroup (see SEAMLESS_TRIGGER). Used for every single-choice segment of a row:
 *  operator word, unit, boolean, event count/duration operator. No custom UI — just the real
 *  ComboboxField, so it matches the enum value picker. */
export function FusedSelect({
  options,
  value,
  onChange,
  ariaLabel,
  placeholder,
  disabled,
}: {
  options: readonly FusedSelectOption[];
  value: string | undefined;
  onChange: (value: string) => void;
  ariaLabel: string;
  placeholder?: string;
  disabled?: boolean;
}) {
  return (
    <ComboboxField
      variant="popup"
      options={options.map((o) => ({
        value: o.value,
        label: o.label,
        ...(o.icon ? { icon: o.icon } : {}),
        ...(o.meta ? { meta: o.meta } : {}),
      }))}
      value={value ?? ''}
      onValueChange={onChange}
      aria-label={ariaLabel}
      placeholder={placeholder}
      className={SEAMLESS_TRIGGER}
      disabled={disabled}
    />
  );
}
